import m from "../../geodata/es2015/indonesiaLow";
window.am4geodata_indonesiaLow = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/indonesiaLow.js
// module id = null
// module chunks = 